import { useMediaQuery } from '@mui/material';
import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function MuiButton(theme) {
  const size = useMediaQuery(theme.breakpoints.down("md")) ? "small" : "medium";

  return {
    MuiButton: {
      defaultProps: {
        size: size,
        color: "primary",
        variant: "contained"
      },
      styleOverrides: {
        root: {
          '&:hover': {
            boxShadow: 'none',
          },
        },
        sizeLarge: {
          height: 48,
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          boxShadow: theme.customShadows.primary,
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary,
        },
        outlinedInherit: {
          color: theme.palette.navy[600],
          border: `1px solid ${alpha(theme.palette.navy[600], 1.0)}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          color: theme.palette.navy[600],
          '&:hover': {
            backgroundColor: theme.palette.navy[600],
          },
        },
        startIcon: {
          marginRight: '4px',
        }
      },
    },
  };
}
